import { render } from "./Navbar.vue?vue&type=template&id=954617cc&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=954617cc&scoped=true&lang=css"

import exportComponent from "C:\\Git_repos\\blendify\\blendify-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-954617cc"]])

export default __exports__